import cleanedFilename from '~/util/cleanedFilename';

export default {
  FLOW_INSTANCE_LIST: `${cleanedFilename(__filename)}-flowinstancelist`,
};
